import { defaultListParams } from '../../../../common/filterTable/constants/defaultListParams';
import { cleanParams } from '../../../../common/filterTable/helpers/cleanParams';
import { FilterFields } from '../types/FilterFields';
import { GetListParams } from '../types/GetAllParams';
import { EnumReferralCodeStatus } from '@wallet-manager/pfh-pmp-node-def-types/dist/src/DbModel/Master';

const useGetListParams = () => {
  const getListParams = (fields: FilterFields) => {
    const {
      consumedSupportedSystem,
      referralCodeStatus: status,
      createdDateFrom: creationTimeFrom,
      createdDateTo: creationTimeTo,
      idvMethod,
      ...rest
    } = fields;

    const getStatusArray = () => {
      if (!status) {
        return [];
      }

      if (status === String(EnumReferralCodeStatus.Expired)) {
        return [String(EnumReferralCodeStatus.Expired), String(EnumReferralCodeStatus.Deleted)];
      }

      return [status];
    };

    const params: GetListParams = {
      ...defaultListParams,
      ...rest,
      kycIdvMethod: idvMethod,
      supportedSystemIds: consumedSupportedSystem,
      statuses: getStatusArray(),
      creationTimeFrom,
      creationTimeTo,
    };

    return cleanParams(params);
  };

  return {
    getListParams,
  };
};

export default useGetListParams;
